var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("view-nav", { attrs: { title: "Admissions" } }),
      _vm._v(" "),
      _c("div", { staticClass: "view-content container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-2" }, [
            _c("ul", { staticClass: "box nav" }, [
              _c(
                "li",
                { staticClass: "nav-item w-100" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: "/admissions/week", "exact-path": "" },
                    },
                    [
                      _c("icon", {
                        staticClass: "red",
                        attrs: { name: "calendar" },
                      }),
                      _vm._v(" Per week\n                        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item w-100" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: "/admissions/day", "exact-path": "" },
                    },
                    [
                      _c("icon", { attrs: { name: "calendar" } }),
                      _vm._v(" Per day\n                        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item w-100" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: "/admissions/year" },
                    },
                    [
                      _c("icon", { attrs: { name: "calendar" } }),
                      _vm._v(" Per year\n                        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item w-100" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: "/admissions/cinema" },
                    },
                    [
                      _c("icon", { attrs: { name: "home" } }),
                      _vm._v(" Per cinema\n                        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item w-100" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: "/admissions/movie" },
                    },
                    [
                      _c("icon", { attrs: { name: "film" } }),
                      _vm._v(" Per movie\n                        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item w-100" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: "/admissions/movie-tag" },
                    },
                    [
                      _c("icon", { attrs: { name: "tag" } }),
                      _vm._v(" Per movie tag\n                        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item w-100" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: "/admissions/sources" },
                    },
                    [
                      _c("icon", { attrs: { name: "file-text" } }),
                      _vm._v(" Source files\n                        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item w-100" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: { to: "/admissions/sync" },
                    },
                    [
                      _c("icon", { attrs: { name: "download" } }),
                      _vm._v(" FTP sync\n                        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box" }, [
              _c(
                "div",
                { staticClass: "box-content" },
                [
                  _c("heading", {
                    attrs: { upper: "Help", border: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "lower",
                        fn: function () {
                          return [
                            _vm._v(
                              "\n                                Browse imported admissions. Click a row to see per-cinema totals,\n                                then click a cinema to see per-title totals.\n                                "
                            ),
                            _c("em", [_vm._v("Per cinema")]),
                            _vm._v(
                              " shows Brightfish admissions per site over the\n                                last 52 weeks, per cinema year and with the top movies per year.\n                                "
                            ),
                            _c("em", [_vm._v("Per movie tag")]),
                            _vm._v(
                              " splits the Brightfish admissions of each cinema\n                                year per Movix target-pack tag, with the top 10 movies per tag.\n                                "
                            ),
                            _c("em", [_vm._v("Per movie")]),
                            _vm._v(
                              " ranks the movies per cinema year and shows, per movie,\n                                its active weeks and the Cinedata titles mapped to it.\n                                "
                            ),
                            _c("em", [_vm._v("Source files")]),
                            _vm._v(
                              " lists the latest raw Cinedata CSVs with their git history,\n                                to see how long after a play date the admissions keep being corrected.\n                                "
                            ),
                            _c("em", [_vm._v("FTP sync")]),
                            _vm._v(
                              " shows the recent downloads from the Cinedata FTP server, compares the\n                                raw folder with the server and can download the last days or one file again.\n                            "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-10" }, [_c("router-view")], 1),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }